import React from 'react';
import { StandardButton } from '@eika/button';
import { ErrorCard } from '@eika/card';
const CreateCaseFailed = _ref => {
  let {
    onCaseCompletionFailedURL
  } = _ref;
  const done = () => {
    if (onCaseCompletionFailedURL) {
      window.location.href = onCaseCompletionFailedURL;
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ErrorCard, {
    title: "Noe gikk galt!",
    description: "Vi kunne ikke lagre svarene dine. Vennligst pr\xF8v igjen senere eller kontakt banken dersom problemene vedvarer"
  }), /*#__PURE__*/React.createElement(StandardButton, {
    type: "button",
    className: "progress-next-button",
    onClick: done,
    id: "questionnaire_button_done"
  }, "Tilbake til oppgavelisten"));
};
export default CreateCaseFailed;